import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useData } from 'crustate/react';
import { ProductListView, HintProductListView } from './View/index.js';

var _excluded = ["data", "variant", "pageSize", "StoreInfoContext", "ProductCardComponent", "hasPagination", "productsPerRow", "exponentiation", "hasNonLinearSlider", "productsLink", "title", "hasFilters", "hasCategorySubNavigation", "filterIcon", "sortIcon", "uiContext", "pointsPriceId", "hasPoints", "images", "heroDescription", "sortButtonSide", "hasTitleParts", "currentBreadcrumb", "loadingText"];
var ProductListViewWrapper = _ref => {
  var data = _ref.data,
      variant = _ref.variant,
      _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? 1 : _ref$pageSize,
      StoreInfoContext = _ref.StoreInfoContext,
      ProductCardComponent = _ref.ProductCardComponent,
      _ref$hasPagination = _ref.hasPagination,
      hasPagination = _ref$hasPagination === void 0 ? true : _ref$hasPagination,
      productsPerRow = _ref.productsPerRow,
      exponentiation = _ref.exponentiation,
      hasNonLinearSlider = _ref.hasNonLinearSlider,
      productsLink = _ref.productsLink,
      title = _ref.title,
      _ref$hasFilters = _ref.hasFilters,
      hasFilters = _ref$hasFilters === void 0 ? true : _ref$hasFilters,
      _ref$hasCategorySubNa = _ref.hasCategorySubNavigation,
      hasCategorySubNavigation = _ref$hasCategorySubNa === void 0 ? false : _ref$hasCategorySubNa,
      filterIcon = _ref.filterIcon,
      sortIcon = _ref.sortIcon,
      uiContext = _ref.uiContext,
      pointsPriceId = _ref.pointsPriceId,
      hasPoints = _ref.hasPoints,
      images = _ref.images,
      heroDescription = _ref.heroDescription,
      sortButtonSide = _ref.sortButtonSide,
      hasTitleParts = _ref.hasTitleParts,
      currentBreadcrumb = _ref.currentBreadcrumb,
      loadingText = _ref.loadingText,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var productListData = useData(data);

  if (productListData.state === "LOADED" || productListData.state === "UPDATING") {
    return /*#__PURE__*/React.createElement(ProductListView, _extends({}, rest, {
      variant: variant,
      productList: productListData.data,
      isUpdating: productListData.state === "UPDATING",
      pageSize: pageSize,
      StoreInfoContext: StoreInfoContext,
      ProductCardComponent: ProductCardComponent,
      hasPagination: hasPagination,
      productsPerRow: productsPerRow,
      exponentiation: exponentiation,
      hasNonLinearSlider: hasNonLinearSlider,
      productsLink: productsLink && productListData.brand ? `/brand/${encodeURIComponent(productListData.brand)}` : "",
      title: title != null ? title : productListData.brand ? productListData.brand : "",
      hasFilters: hasFilters,
      hasCategorySubNavigation: hasCategorySubNavigation,
      filterIcon: filterIcon,
      sortIcon: sortIcon,
      uiContext: uiContext,
      pointsPriceId: pointsPriceId,
      hasPoints: hasPoints,
      images: images,
      heroDescription: heroDescription,
      sortButtonSide: sortButtonSide,
      hasTitleParts: hasTitleParts,
      currentBreadcrumb: currentBreadcrumb != null ? currentBreadcrumb : productListData.brand
    }));
  }

  return /*#__PURE__*/React.createElement(HintProductListView, {
    title: title != null ? title : productListData.state === "LOADING" && productListData.brand ? productListData.brand : "",
    StoreInfoContext: StoreInfoContext,
    loadingText: loadingText
  });
};

export { ProductListViewWrapper };
//# sourceMappingURL=index.js.map
